import { FocusEvent } from "react";
import { TextInput, formatNumber } from "@narmi/design_system";

interface AmountTextInputProps {
  onChange?: CallableFunction;
  value?: string;
  field?: string;
  label: string;
  disabled?: boolean;
  testId?: string;
  onBlur?: (e: FocusEvent<HTMLInputElement>) => void;
}

const AmountTextInput = ({
  onChange = () => {},
  value = "",
  label,
  onBlur,
  ...textInputProps
}: AmountTextInputProps) => {
  const displayValue = value && value[0] !== "$" ? `$${value}` : value;
  const handleInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    const parsedValue = event.target.value.replace(/[^\d.]/g, "");
    if (!parsedValue.match(/^\d*.{0,1}\d{0,2}$/)) return;
    if (!parsedValue) {
      onChange("$");
      return;
    }
    onChange(parsedValue);
  };
  const onFocus = () => {
    if (!value) onChange("$");
  };
  const handleBlur = (e: FocusEvent<HTMLInputElement>) => {
    onBlur?.(e);

    if (value === "$") {
      onChange("");
      return;
    }
    const strippedValue = value.replace(/[$,]/g, "");
    onChange(formatNumber(strippedValue));
  };
  return (
    <TextInput
      onChange={handleInput}
      value={displayValue}
      onFocus={onFocus}
      onBlur={handleBlur}
      inputMode="decimal"
      label={label}
      {...textInputProps}
    />
  );
};
export default AmountTextInput;
